<mat-form-field appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <mat-select [disabled]="disabled" #estadoSelect [value]="selectedEstadoId" (selectionChange)="doSelected($event)">
    <mat-option *ngIf="verTodos" [value]="-1">Todos</mat-option>
    <mat-option *ngFor="let estado of estados" [value]="estado?.key">
      {{ estado?.value }}
    </mat-option>
  </mat-select>
</mat-form-field>
